(function () {
  "use strict";

  var money = function (cents, cash) {
    if (cash && typeof cash.formatMoney === "function") return cash.formatMoney(cents);
    var n = (cents / 100).toFixed(2);
    return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  var qs = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  var qsa = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  function on(el, ev, fn) {
    if (el) el.addEventListener(ev, fn);
  }

  /* Header scroll */
  var header = qs("[data-site-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 80);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile nav */
  var mobile = qs("[data-mobile-nav]");
  qsa("[data-open-menu]").forEach(function (btn) {
    on(btn, "click", function () {
      if (mobile) mobile.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  });
  qsa("[data-close-menu]").forEach(function (btn) {
    on(btn, "click", function () {
      if (mobile) mobile.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  });
  qsa("[data-mobile-nav] a").forEach(function (a) {
    on(a, "click", function () {
      if (mobile) mobile.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  });

  /* FAQ */
  qsa("[data-faq-item]").forEach(function (item) {
    var btn = qs("button", item);
    on(btn, "click", function () {
      var open = item.classList.contains("is-open");
      qsa("[data-faq-item]").forEach(function (other) {
        other.classList.remove("is-open");
        var b = qs("button", other);
        var m = qs(".mark", other);
        if (b) b.setAttribute("aria-expanded", "false");
        if (m) m.textContent = "+";
      });
      if (!open) {
        item.classList.add("is-open");
        if (btn) btn.setAttribute("aria-expanded", "true");
        var mark = qs(".mark", item);
        if (mark) mark.textContent = "−";
      }
    });
  });
  var firstFaq = qs("[data-faq-item]");
  if (firstFaq) {
    firstFaq.classList.add("is-open");
    var fb = qs("button", firstFaq);
    var fm = qs(".mark", firstFaq);
    if (fb) fb.setAttribute("aria-expanded", "true");
    if (fm) fm.textContent = "−";
  }

  /* Legal tabs */
  qsa("[data-legal-tab]").forEach(function (tab) {
    on(tab, "click", function () {
      var id = tab.getAttribute("data-legal-tab");
      qsa("[data-legal-tab]").forEach(function (t) {
        t.classList.toggle("is-on", t === tab);
      });
      qsa("[data-legal-panel]").forEach(function (p) {
        p.hidden = p.getAttribute("data-legal-panel") !== id;
      });
    });
  });

  /* Bottle image toggle (closed / open) — pointer only, no double-fire */
  qsa("[data-bottle]").forEach(function (stage) {
    var img = qs("img", stage);
    var closed = stage.getAttribute("data-closed");
    var opened = stage.getAttribute("data-open");
    if (!img || !closed || !opened) return;
    var showing = "closed";
    on(img, "click", function (e) {
      e.preventDefault();
      showing = showing === "closed" ? "open" : "closed";
      img.src = showing === "closed" ? closed : opened;
    });
  });

  /* Cart */
  var overlay = qs("[data-cart-overlay]");
  var cartImg = overlay ? overlay.getAttribute("data-cart-img") || "" : "";
  var lastCart = { items: [], item_count: 0, total_price: 0 };
  var pending = {};
  var inFlight = {};
  var syncing = false;
  var calculating = false;
  var addLock = false;

  function openCart() {
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function updateCount(n) {
    qsa("[data-cart-count]").forEach(function (el) {
      el.textContent = String(n);
    });
  }

  function mergedItems() {
    return lastCart.items
      .map(function (item) {
        var qty = pending.hasOwnProperty(item.key)
          ? pending[item.key]
          : inFlight.hasOwnProperty(item.key)
            ? inFlight[item.key]
            : item.quantity;
        if (qty < 1) return null;
        var unit = item.quantity > 0 ? item.final_line_price / item.quantity : item.final_line_price;
        var basePrice = item.selling_plan_allocation ? unit : item.original_price || unit;
        return {
          key: item.key,
          product_title: item.product_title,
          quantity: qty,
          properties: item.properties,
          selling_plan_allocation: item.selling_plan_allocation,
          base_price: basePrice,
          original_price: item.original_price || unit,
          final_line_price: priceForQuantity(item, qty),
        };
      })
      .filter(Boolean);
  }

  function lineHtml(item) {
    var props = "";
    var decreaseDisabled = item.quantity <= 1 ? ' disabled aria-disabled="true"' : "";
    if (item.selling_plan_allocation) props = " · Subscribe";
    return (
      '<li class="cart-line">' +
      '<div class="cart-thumb"><img src="' +
      cartImg +
      '" alt=""></div>' +
      "<div style='flex:1'>" +
      "<h3>" +
      item.product_title +
      "</h3>" +
      '<p class="meta">' +
      item.quantity +
      " bottle" +
      (item.quantity > 1 ? "s" : "") +
      props +
      "</p>" +
      '<div class="qty-row">' +
      '<button type="button" class="qty-btn" data-qty-change="' +
      item.key +
      '" data-qty="' +
      (item.quantity - 1) +
      '" aria-label="Decrease"' +
      decreaseDisabled +
      ">−</button>" +
      "<span>" +
      item.quantity +
      "</span>" +
      '<button type="button" class="qty-btn" data-qty-change="' +
      item.key +
      '" data-qty="' +
      (item.quantity + 1) +
      '" aria-label="Increase">+</button>' +
      "</div></div>" +
      '<div class="price">' +
      money(item.final_line_price) +
      "<br>" +
      '<button type="button" class="cart-remove" data-qty-change="' +
      item.key +
      '" data-qty="0">Remove</button>' +
      "</div></li>"
    );
  }

  function volumeDiscountRate(item, quantity) {
    if (item.selling_plan_allocation) return 0;
    if (quantity >= 4) return 0.25;
    if (quantity >= 3) return 0.2;
    if (quantity >= 2) return 0.15;
    return 0;
  }

  function priceForQuantity(item, quantity) {
    var unit = Number(item.base_price || item.original_price || item.final_line_price / Math.max(item.quantity, 1));
    var rate = volumeDiscountRate(item, quantity);
    // Shopify applies automatic percentage discounts to each unit, rounding the
    // discount down to whole cents before calculating the line total.
    return (unit - Math.floor(unit * rate)) * quantity;
  }

  function paintCart() {
    var items = mergedItems();
    var count = items.reduce(function (s, i) {
      return s + i.quantity;
    }, 0);
    var total = items.reduce(function (s, i) {
      return s + i.final_line_price;
    }, 0);
    var undiscounted = items.reduce(function (s, i) {
      return s + Number(i.original_price || 0) * i.quantity;
    }, 0);
    updateCount(count);
    var body = qs("[data-cart-body]");
    var sub = qs("[data-cart-subtotal]");
    if (body) {
      if (!items.length) {
        body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      } else {
        body.innerHTML = "<ul>" + items.map(lineHtml).join("") + "</ul>";
      }
    }
    if (sub) sub.textContent = money(total);
    var discount = qs("[data-cart-discount]");
    if (discount) {
      var savings = Math.max(0, undiscounted - total);
      var hasSubscription = items.some(function (i) { return !!i.selling_plan_allocation; });
      discount.hidden = savings < 1 && !hasSubscription;
      discount.textContent = savings > 0 ? "Discount applied — you save " + money(savings) : hasSubscription ? "Subscription discount applied" : "";
    }
    qsa("[data-qty-input]").forEach(function (input) {
      var key = input.getAttribute("data-qty-input");
      var match = items.find(function (i) {
        return i.key === key;
      });
      if (match) input.value = String(match.quantity);
    });
    setCalculating(calculating);
  }

  function setCalculating(active) {
    calculating = active;
    var indicator = qs("[data-cart-calculating]");
    if (indicator) indicator.hidden = !active;
    if (overlay) overlay.setAttribute("aria-busy", active ? "true" : "false");
    qsa(".qty-btn").forEach(function (button) {
      var isDecreaseAtMinimum = Number(button.getAttribute("data-qty")) < 1;
      button.disabled = active || isDecreaseAtMinimum;
      button.setAttribute("aria-disabled", button.disabled ? "true" : "false");
    });
  }

  function bindCartClicks(root) {
    on(root || document, "click", function (e) {
      var t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      var b = t && t.closest ? t.closest("[data-qty-change]") : null;
      if (!b) return;
      if (b.disabled) return;
      e.preventDefault();
      var key = b.getAttribute("data-qty-change");
      var qty = Number(b.getAttribute("data-qty"));
      if (!key) return;
      queueQty(key, qty);
    });
  }

  function queueQty(key, qty) {
    if (syncing || qty < 0) return;
    pending[key] = qty;
    setCalculating(true);
    flushQty();
  }

  function flushQty() {
    if (syncing) return;
    var keys = Object.keys(pending);
    if (!keys.length) return;
    var key = keys[0];
    var qty = pending[key];
    delete pending[key];
    inFlight[key] = qty;
    syncing = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function (cart) {
        lastCart = cart;
        delete inFlight[key];
        syncing = false;
        setCalculating(false);
        paintCart();
        if (Object.keys(pending).length) {
          setCalculating(true);
          flushQty();
        }
      })
      .catch(function () {
        delete inFlight[key];
        syncing = false;
        setCalculating(false);
        refreshCart(false);
      });
  }

  function refreshCart(open) {
    return fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        lastCart = cart;
        paintCart();
        if (open) openCart();
        return cart;
      })
      .catch(function () {
        if (open) window.location.href = "/cart";
      });
  }

  qsa("[data-open-cart]").forEach(function (b) {
    on(b, "click", function (e) {
      e.preventDefault();
      openCart();
      refreshCart(true);
    });
  });
  qsa("[data-close-cart]").forEach(function (b) {
    on(b, "click", closeCart);
  });
  bindCartClicks(document);

  /* Pack + subscribe + add to cart */
  function bindOffer(root) {
    if (!root) return;
    var qtyInput = qs("[name='quantity']", root);
    var priceEl = qs("[data-price-now]", root);
    var compareEl = qs("[data-price-was]", root);
    var compareWrap = qs("[data-price-was-wrap]", root);
    var noteEl = qs("[data-price-note]", root);
    var addBtn = qs("[data-add]", root);
    var unit = Number(root.getAttribute("data-unit") || "12999");
    var compare = Number(root.getAttribute("data-compare") || "0");
    var shopCurrency = root.getAttribute("data-shop-currency") || "USD";
    var presentmentCurrency = root.getAttribute("data-presentment-currency") || shopCurrency;
    var localizedUnit = root.getAttribute("data-localized-unit") || money(unit);
    var isShopCurrency = shopCurrency === presentmentCurrency;
    var variantId = root.getAttribute("data-variant");
    var sellingPlanId = root.getAttribute("data-selling-plan");
    var sellingPlanInput = qs("[data-selling-plan-input]", root);
    var state = { qty: 1, subscribe: false };

    function packSave(q) {
      if (q === 2) return 0.15;
      if (q === 3) return 0.2;
      if (q >= 4) return 0.25;
      return 0;
    }
    function total() {
      if (state.subscribe) return Math.floor(unit * 0.85) * state.qty;
      var rate = packSave(state.qty);
      return (unit - Math.floor(unit * rate)) * state.qty;
    }
    function render() {
      qsa("[data-pack]", root).forEach(function (b) {
        b.classList.toggle("is-selected", Number(b.getAttribute("data-pack")) === state.qty);
        var save = qs("[data-pack-save]", b);
        if (save) {
          var quantity = Number(b.getAttribute("data-pack"));
          save.textContent = state.subscribe && quantity > 1 ? "Subscription price" : save.getAttribute("data-pack-save");
        }
      });
      var sw = qs("[data-subscribe]", root);
      if (sw) {
        sw.classList.toggle("is-on", state.subscribe);
        sw.setAttribute("aria-checked", state.subscribe ? "true" : "false");
      }
      if (qtyInput) qtyInput.value = String(state.qty);
      if (sellingPlanInput) sellingPlanInput.value = state.subscribe ? sellingPlanId : "";
      if (priceEl) {
        priceEl.textContent = isShopCurrency ? money(total()) : localizedUnit;
      }
      if (compareEl) compareEl.textContent = money(compare * state.qty);
      if (compareWrap) compareWrap.hidden = !(isShopCurrency && compare > unit);
      if (noteEl) {
        if (!isShopCurrency && (state.subscribe || state.qty > 1)) {
          noteEl.textContent = state.subscribe
            ? "Subscribe & Save 15% applies at checkout in your local currency · ships every 6 weeks"
            : "Pack savings apply automatically at checkout in your local currency";
        } else {
          noteEl.textContent = state.subscribe
            ? "Subscribe & Save 15% · ships every 6 weeks · does not combine with pack discounts"
            : "One-time purchase";
        }
      }
      if (addBtn && !addLock) addBtn.textContent = state.subscribe ? "Subscribe & Save" : "Add to Cart";
    }

    qsa("[data-pack]", root).forEach(function (b) {
      on(b, "click", function () {
        state.qty = Number(b.getAttribute("data-pack")) || 1;
        render();
      });
    });
    on(qs("[data-subscribe]", root), "click", function () {
      state.subscribe = !state.subscribe;
      render();
    });
    on(root, "submit", function (e) {
      if (!variantId) return;
      e.preventDefault();
      if (addLock) return;
      addLock = true;
      var original = addBtn ? addBtn.textContent : "";
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = "Adding…";
      }
      openCart();
      var payload = {
        items: [
          {
            id: Number(variantId),
            quantity: state.qty,
            selling_plan: state.subscribe && sellingPlanId ? Number(String(sellingPlanId).match(/(\d+)$/)[1]) : undefined,
          },
        ],
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(function () {
          return refreshCart(true);
        })
        .then(function () {
          addLock = false;
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = state.subscribe ? "Subscribe & Save" : "Add to Cart";
          }
        })
        .catch(function () {
          addLock = false;
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = original;
          }
          e.target.submit();
        });
    });
    render();
  }
  qsa("[data-offer]").forEach(bindOffer);

  /* Sticky bar */
  var bar = qs("[data-sticky-bar]");
  var hero = document.getElementById("hero");
  var offer = document.getElementById("offer");
  if (bar && hero && "IntersectionObserver" in window) {
    var heroIn = true;
    var offerIn = false;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.target.id === "hero") heroIn = e.isIntersecting;
          if (e.target.id === "offer") offerIn = e.isIntersecting;
        });
        bar.classList.toggle("is-visible", !heroIn && !offerIn);
      },
      { threshold: 0.12 }
    );
    io.observe(hero);
    if (offer) io.observe(offer);
  }

  /* Initial cart count */
  fetch("/cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      lastCart = cart;
      paintCart();
    })
    .catch(function () {});

  /* Journal */
  qsa("[data-journal-index] button").forEach(function (btn) {
    on(btn, "click", function () {
      var id = btn.getAttribute("data-article");
      qsa("[data-journal-index] button").forEach(function (b) {
        b.classList.toggle("is-on", b === btn);
      });
      qsa("[data-journal-article]").forEach(function (art) {
        art.hidden = art.getAttribute("data-journal-article") !== id;
      });
    });
  });

  /* Hash → legal tab */
  if (location.hash) {
    var hash = location.hash.replace("#", "");
    var tab = qs('[data-legal-tab="' + hash + '"]');
    if (tab) tab.click();
  }

  /* Newsletter popup — 5s, Shopify customer form, persists dismiss */
  var popup = qs("[data-nl-popup]");
  if (popup) {
    var posted = !!qs("[data-nl-success]", popup);
    var dismissed = false;
    try {
      dismissed = localStorage.getItem("pistis-nl") === "1";
    } catch {}
    function closeNl() {
      popup.hidden = true;
      document.body.style.overflow = "";
      try {
        localStorage.setItem("pistis-nl", "1");
      } catch {}
    }
    qsa("[data-nl-close]", popup).forEach(function (b) {
      on(b, "click", closeNl);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !popup.hidden) closeNl();
    });
    if (posted) {
      popup.hidden = false;
      try {
        localStorage.setItem("pistis-nl", "1");
      } catch {}
    } else if (!dismissed) {
      setTimeout(function () {
        popup.hidden = false;
      }, 5000);
    }
  }
})();
